import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class BomSourcesIndexRoute extends AuthenticatedRoute {
  resetController(controller) {
    super.resetController(...arguments);
    controller.selectedBomSource = null;
  }
}
